// extracted by mini-css-extract-plugin
export default {"container":"s4tNRbcowOBZfoP1I4Z6","roomImage":"_37kDgYsNUL32vFJfeLp","moreImages":"QQ8IwLqNdeKhIYuSitgz","icon":"ofkJrYss0IUuNYjRyu2c"};